!function($, window, document) {
    const $win = $(window), $doc = $(document), $header = $(".header");
    let isBreakpointMobile = window.matchMedia("(max-width: 767px)").matches;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    function setClassIfDeviceIsPortrait() {
        window.matchMedia("(orientation: portrait)").matches ? $("body").addClass("is-portrait") : $("body").removeClass("is-portrait");
    }
    function calcHeaderHeightWidth() {
        $("body").css("--header-h", `${$header.outerHeight()}px`), $("body").css("--header-w", `${$header.outerWidth()}px`);
    }
    calcHeaderHeightWidth(), $(".nav a").on("click", (function(e) {
        const targetId = $(this).attr("href");
        if ("#enquire" !== targetId) return;
        e.preventDefault();
        const targetElement = $(targetId);
        if ($("html, body").animate({
            scrollTop: targetElement.offset().top
        }, 700), $(".js-slider-page").length) {
            const slideIndex = targetElement.closest(".slick-slide").attr("data-slick-index");
            $(".js-slider-page .slick-slider").slick("slickGoTo", parseInt(slideIndex));
        }
    })), $win.on("load", (() => {
        setClassIfDeviceIsPortrait(), isSafari && $("body").addClass("is-safari"), isBreakpointMobile && $("body").addClass("is-touch"), 
        $(".form__foot a, .section__nav a").removeAttr("tabindex").attr({
            target: "_blank",
            rel: "noopener"
        });
    })).on("resize", (() => {
        isBreakpointMobile = window.matchMedia("(max-width: 767px)").matches, calcHeaderHeightWidth(), 
        setClassIfDeviceIsPortrait(), isBreakpointMobile ? $("body").addClass("is-touch") : $("body").removeClass("is-touch");
    })), $doc.on("gform_confirmation_loaded", (function() {
        $(".form").addClass("form--success");
    }));
}(jQuery, window, document);